import { useEffect, useState } from "react";
import "./NotificationPermissionBanner.css";
import Icon from "../base/Icon";
import { NOTIF_PERMISSION_NEVER_KEY } from "../../core/Constants";
import { useNotificationPermission } from "../../hooks/useNotificationPermission";


// "Never show" is only never for the signed-in user: logout clears the flag (see
// core/Global logout), so the next person to sign in on this machine is asked once too.
const NEVER_KEY = NOTIF_PERMISSION_NEVER_KEY


function silencedForGood() {
    try {
        return window.localStorage.getItem(NEVER_KEY) == "1"
    }
    catch {
        return false
    }
}


export default function NotificationPermissionBanner() {

    const perm = useNotificationPermission()

    const [never, neverSet] = useState<boolean>(silencedForGood)
    // The app asks for the permission itself on load; this waits out the browser's own
    // prompt so the two don't land on the user at the same moment.
    const [ready, readySet] = useState<boolean>(false)

    useEffect(() => {
        const timer = setTimeout(() => readySet(true), 5000)
        return () => clearTimeout(timer)
    }, [])

    if (!ready) return null
    if (!perm.supported || perm.granted) return null
    if (never) return null

    const blocked = perm.blocked
    const askedInChrome = perm.askedInBrowser
    const working = perm.working
    const ask = perm.ask

    const silenceForGood = () => {
        try {
            window.localStorage.setItem(NEVER_KEY, "1")
        }
        catch { }
        neverSet(true)
    }

    return (
        <div className="notif-perm-wrap">
        <div className="notif-perm">

            <div className="notif-perm-arrow"></div>

            <div className="notif-perm-icon">
                <Icon icon={blocked ? "bell-slash" : "bell-on"} type="solid" size={15} />
            </div>

            <div className="notif-perm-body">
                <div className="notif-perm-title">
                    {blocked ? "Notifications are blocked" : "Turn on notifications"}
                </div>
                <div className="notif-perm-text">
                    {
                        blocked ?
                            <>Open the site settings from the icon on the left of the address bar and set <b>Notifications</b> to <b>Allow</b>.</>
                            : askedInChrome ?
                                <>Your browser is asking up in the address bar — open the icon there and choose <b>Allow</b>.</>
                                : <>Rinvox needs your permission to tell you about new chat messages while it is in the background.</>
                    }
                </div>

                <div className="notif-perm-actions">
                    <button type="button" className="btn btn-sm btn-light"
                        onClick={silenceForGood}>
                        Never Show
                    </button>

                    {
                        !blocked &&
                        <button type="button" className="btn btn-sm btn-primary" disabled={working}
                            onClick={ask}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Waiting...</span>
                                    </>
                                    : <>Allow Notifications</>
                            }
                        </button>
                    }
                </div>
            </div>

        </div>
        </div>
    )
}
